import apiClient from './apiClient'

const REJECTION_REASON_BODY = Object.freeze({ institution: '', name: '' })
export const createRejectionReason = (user, body = REJECTION_REASON_BODY) => {
  return apiClient.post(user, 'api/RejectionReason', body)
}

export const updateRejectionReason = (user, reason, body = REJECTION_REASON_BODY) => {
  return apiClient.patch(user, `api/RejectionReason/${reason.id}`, body)
}

export const deleteRejectionReason = (user, reason) => apiClient.delete(user, `api/RejectionReason/${reason.id}`)
